import { defineComponent as _defineComponent } from 'vue'
import { InviteLinks } from '@busy-human/opt-library'
import VTextField from "@busy-human/vue-component-library/components/text-field.vue"
import { ref } from 'vue'

type Props = {
    invite: InviteLinks.Model
}
type Emits = {
    (e: 'update:invite', invite: InviteLinks.Model): void
    (e: 'progress'): void
    (e: 'previous'): void
}

export default /*#__PURE__*/_defineComponent({
  __name: 'invite-name',
  props: {
    invite: null
  },
  emits: ["update:invite", "progress", "previous"],
  setup(__props: any, { expose, emit }: { emit: ({
    (e: 'update:invite', invite: InviteLinks.Model): void
    (e: 'progress'): void
    (e: 'previous'): void
}), expose: any, slots: any, attrs: any }) {
  expose();

const props = __props as {
    invite: InviteLinks.Model
}


const rows= ref("2")


const name = ref<string | undefined>();

const setName = () => {
    if(name.value)
        emit('update:invite', { ...props.invite, name: name.value });
    emit('progress');
}
const proceed = () => {
    emit('progress');
}


const __returned__ = { props, rows, emit, name, setName, proceed, InviteLinks, VTextField, ref }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})